import { useCallback } from 'react';
import { useComponentConfig } from 'js/hooks/component/useComponentConfig';
import { useComponentMethods } from 'js/hooks/component/useComponentMethods';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as server from '../server';
import * as actions from '../store/actions';
import { useDynamicReducerDispatch } from '../store';
import { RETAIL_CARD_NUMBER_TAG, SYSTEM_TO_PLAYER_TAG_MAP } from '../constants';

export const useFetchPlayerTags = () => {
    const { system } = useComponentConfig();
    const translate = useComponentTranslations();
    const walletIdTag = SYSTEM_TO_PLAYER_TAG_MAP[system];
    const dynamicReducerDispatch = useDynamicReducerDispatch();
    const { showComponentError, showComponentMessage } = useComponentMethods();

    return useCallback(async () => {
        const response = await server.getPlayerTags({
            tagNames: [walletIdTag, RETAIL_CARD_NUMBER_TAG]
        });
        const { tags } = response.data;
        const walletId = tags.find((tag) => tag.name === walletIdTag);
        const retailCardNumber = tags.find((tag) => tag.name === RETAIL_CARD_NUMBER_TAG);

        if (!retailCardNumber) {
            showComponentError(translate('retailCardNumber.not-defined'));
            return;
        }

        if (walletId) {
            showComponentMessage(translate('walletId.already-linked', [walletId, translate(`system.${system}`)]));
            return;
        }

        dynamicReducerDispatch(actions.setRetailCardNumber(retailCardNumber.value));
    }, [
        dynamicReducerDispatch,
        showComponentMessage,
        showComponentError,
        walletIdTag,
        system,
        translate
    ]);
};
